import { WashPlanService } from "@/app/plans/wash/services/wash.plan.service"


const initPlanData = {
  type: 'wash',
  name: null,
  device_id: null,
  camp_id:null,
  camp_leave: null,
  camp_back: null,
  route: null,
 
  containers_excl_file:null,
  
}




const initialState = () => {
  return {
    loading: false,
    errors: {},
    data: Object.assign({}, initPlanData)
  }
}


const state = initialState()

const mutations = {

  RESET_STORE_DATA(state) {
    Object.assign(state, { ...initialState() })
  },

  REQUEST_SEND(state) {

    Object.assign(state, {
      loading: true,
      errors: {}
    })
  },

  REQUEST_FINISHED(state) {
    Object.assign(state, {
      loading: false,
    })
  },


  SET_PLAN_DATA(state, data) {
    

    Object.assign(state.data, {
      ...data,
      route: data.data.route,
     

    })

    delete state.data.data

  },

  

  REQUEST_SUCCESS(state) {
    Object.assign(state, {
      data: Object.assign({}, initPlanData),
      errors: {},
      loading: false
    })
  },

  REQUEST_ERROR(state, error) {
    Object.assign(state, {
      errors: error,
      loading: false
    })
  },



}


const actions = {

  createPlan(context) {

    const formData = new FormData();
    formData.append("name",context.state.data.name)
    formData.append("type","wash")
    formData.append("device_id",context.state.data.device_id)
    formData.append("camp_id",context.state.data.camp_id)
    formData.append("camp_leave",context.state.data.camp_leave)
    formData.append("camp_back",context.state.data.camp_back)
    formData.append("route",context.state.data.route)
    formData.append("containers_excl_file",context.state.data.containers_excl_file)
   

  


    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      WashPlanService.createPlan(formData).then(res => {
        context.commit('REQUEST_SUCCESS')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },


  updatePlan(context, id) {
    const formData = new FormData();
    formData.append("id",id)
    formData.append("name",context.state.data.name)
    formData.append("type","wash")
    formData.append("device_id",context.state.data.device_id)
    formData.append("camp_id",context.state.data.camp_id)
    formData.append("camp_leave",context.state.data.camp_leave)
    formData.append("camp_back",context.state.data.camp_back)
    formData.append("route",context.state.data.route)
    formData.append("containers_excl_file",context.state.data.containers_excl_file)
    
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      WashPlanService.updatePlan(id, formData).then(res => {
        context.commit('REQUEST_FINISHED')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  getPlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      WashPlanService.getPlanById(id).then(res => {
        context.commit('SET_PLAN_DATA', res)
  
        context.commit('REQUEST_SUCCESS')
        context.commit('SET_PLAN_DATA', res)
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  deletePlan(context, id, PlanType) {
    return new Promise((resolve, reject) => {
      WashPlanService.deletePlan(id, PlanType).then(res => resolve(res))
        .catch(reason => reject(reason))
    })
  },

}




export default {
  namespaced: true,
  state,
  mutations,
  actions
};
